import React, { Component, Fragment } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Rest from "../../services/Rest";
import Can from "../../config/Can";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

const initialState = {
    reportHidden: "hidden",
    reporte: {
        campaña: [],
        datoscsv: [],
        dias: [],
        respuestas: [],
        total_cola: 0,
        usuario: []
    }
}

class rcampaings extends Component {

    constructor(props) {
        super(props)
        this.Can = new Can();
        this.Rest = new Rest();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
        this.state = { ...initialState };
    }

    handlePrint() {
        const input = document.getElementById('divToPrint');
        html2canvas(input)
            .then((canvas) => {
                const pdf = new jsPDF("1", "mm", "a4");
                const imgData = canvas.toDataURL('image/png', 1.0);
                pdf.addImage(imgData, 'JPEG', 0, 0);
                pdf.save("reporte.pdf");
            })

    }

    componentDidMount() {
        this.Rest.get('reportes/campanas/' + this.props.match.params.id, this.datauser)
            .then(resp => {
                if (resp.status === 200) {
                    this.setState({
                        reporte: resp.data,
                        reportHidden: ""
                    })
                }
                else {
                    if (resp.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            error: true,
                            errorMessage: resp.message
                        })
                    }
                }
            })
            .catch(err => {
                this.setState({
                    error: true,
                    errorMessage: "Error de respuesta del servidor"
                })
            })
    }



    handlePrint() {
        const input = document.getElementById('toprint');
        html2canvas(input)
            .then((canvas) => {
                const pdf = new jsPDF("1", "mm", "a4");
                const imgData = canvas.toDataURL('image/png', 1.0);
                pdf.addImage(imgData, 'JPEG', 0, 0);
                pdf.save("reporte.pdf");
            })

    }


    render() {

        const { reportHidden, reporte } = this.state;
        return (
            <Fragment>
                <div className={reportHidden} id="toprint">

                    <div className="container bg-white document">
                        <div className="row">
                            <div className="d-flex document-header">
                                <div className="mr-auto">
                                    <img src="/images/logo-sms-rapidos.jpeg" className="img-responsive img-navbar" />
                                </div>
                                <div>
                                    <h3>Reporte de campaña</h3>
                                    <p>{reporte.campaña.nombre}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <blockquote>
                                <p>
                                    <b>Fecha de actividad de la campaña</b>
                                </p>
                                <p>Fecha de {reporte.campaña.fechaInicio} hasta {reporte.campaña.fechaFinalizacion}, de {reporte.campaña.horaInicio} a {reporte.campaña.horaFinalizacion} hrs.</p>
                                <p>Activa los días</p>
                                <ul className="list-inline">
                                    {reporte.dias ? reporte.dias.map((dia, index) => (
                                        <li key={index} className="list-inline-item badge badge-secondary">{dia}</li>
                                    )) : null}
                                </ul>
                            </blockquote>
                        </div>
                        <div className="row">
                            <p><b>Los datos CSV contenidos en la campaña actualmente es de:</b></p>
                            <p>{reporte.total_cola}</p>
                        </div>
                        <div className="row">
                            <p>Respuestas automatizadas</p>
                            <ul className="list-inline">
                                {reporte.respuestas ? reporte.respuestas.map((val, i) => (
                                    <li key={i}
                                        className="list-inline-item">Clave: <b>{val.clave}</b> Respuesta: <b>{val.respuesta}</b>
                                    </li>
                                )) : "La campaña no cuenta con respuestas automatizadas."}
                            </ul>
                        </div>
                        <div className="row">
                            <p>
                                <b>Creador de la campaña</b>
                            </p>
                            <p>{reporte.usuario.nombre} {reporte.usuario.apellidos}</p>
                            <p>
                                <b>Otros datos</b>
                            </p>
                            <p>${reporte.usuario.precio}</p>
                            <p>{reporte.usuario.ip}</p>
                            <p>{reporte.usuario.correo}</p>
                            <p>{reporte.usuario.habilitar === "1" ? <span className="badge badge-success">IP Habilitada</span> : <span className="badge badge-danger">IP Deshabilitada</span>}</p>
                        </div>
                    </div>





                </div>
                <div className="container">
                    <button type="button" className="btn btn-primary" onClick={this.handlePrint}>Imprimir</button>
                    <Link to="/consulta-de-campañas" className="btn btn-secondary ml-3">&laquo; Volver</Link>
                </div>
            </Fragment>
        );
    }
}

export default withRouter(rcampaings);


// WEBPACK FOOTER //
// ./src/components/reports/rcampaigns.js